import { useAppDispatch } from '../../../../../../../hooks';
import { storeForm } from '../../../../../../../state/ui/forms';
import { sourceSetIds } from '../../../../../../../state/types';
import { useCreatorLevel } from '../../../../../selectors/index.hooks';
import { FormikValues } from 'formik';
import {
    activatePreviewWithSelectedOptions,
    IActivatePreviewParams,
} from '../../../../../../../state/ui/discovery/snapshotting';
import { hideTopDialog } from '../../../../../../../state/ui/dialog';

export const useAddLocation = () => {
    const dispatch = useAppDispatch();
    const creatorLevel = useCreatorLevel();

    const handleAddLocation = (values: FormikValues) => {
        dispatch(storeForm({ form: values, type: 'task' }));
        const params: IActivatePreviewParams = {
            elementCollectionName: sourceSetIds.locations,
            elementId: '',
            elementType: 'location',
            mode: 'add',
            snapshot: {
                type: 'preview',
                level: creatorLevel + 1,
                storeResult: 'task',
            },
            fitMap: false,
            actionsToTrigger: [{ type: 'restoreDialog' }],
        };
        dispatch(hideTopDialog());
        dispatch(activatePreviewWithSelectedOptions(params));
    };

    return handleAddLocation;
};
